import { Video } from '@models/Video'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type VideoItemProps = {
  video: Video
  onClick: () => void
  listRule?: 'sp' | 'tab' | 'smallTab' | 'pc' | 'no-list'
}
const VideoItem = ({ video, onClick, listRule = 'sp' }: VideoItemProps) => {
  const { locale } = useTranslation()

  return (
    <button className={style.video} data-list-rule={listRule} onClick={onClick}>
      <img
        src={`https://i.ytimg.com/vi/${video.videoId}/hqdefault.jpg`}
        alt={locale === 'ja' ? video.title : video.titleEn}
      />
      <div>
        <div className={style.title}>
          {locale === 'ja' ? video.title : video.titleEn}
        </div>
        <div className={style.tags}>
          {(locale === 'ja' ? video.tags : video.tagsEn).map(tag => (
            <span className={style.tag} key={tag}>
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </button>
  )
}

export default VideoItem
